<template>
  <a :href="id" class="absolute inline-flex flex-row items-center top-0 left-0 m-2 px-3 py-2 text-lg font-medium text-black bg-app-blue--egyptian z-50 u-clip u-focus--skiplink">
    <span class="u-flex">{{ text }}</span>
    <AtomIconArrowRight class="w-5 h-5 ml-4" />
  </a>
</template>

<script setup lang="ts">
defineProps({
  id: { type: String, required: true },
  text: { type: String, required: true },
})
</script>

<style lang="css" scoped>
.u-clip {
  clip-path: inset(0 100% 100% 0);
}

.u-focus--skiplink:focus-visible {
  position: relative;
  clip-path: none;
}
</style>
